// extracted by mini-css-extract-plugin
export default {"container":"CasinoSearchBackHeader_container--cDQ","back":"CasinoSearchBackHeader_back--Omu","title":"CasinoSearchBackHeader_title--vcs"};